import React from "react";
import { Grid, Box, Typography } from "@mui/material";
import * as dateFns from "date-fns";

const CalendarCells = ({
  startDate,
  endDate,
  currentDate,
  selectedDates,
  onDateClick,
  holidayList,
  satSunList,
  presentList,
  regApprovedList,
  regPendingList,
  absentList,
  weekendPolicyList,
  absentPresentData, // Attendance data from API
  leaveListSession,
}) => {
  const dateFormat = "dd";
  const rows = [];

  const startDayOfWeek = dateFns.getDay(startDate);

  let days = [];
  let day = dateFns.subDays(startDate, startDayOfWeek);

  const endOfWeek = dateFns.endOfWeek(endDate);

  // console.log("leaveListSession", leaveListSession);

  while (day <= endOfWeek) {
    for (let i = 0; i < 7; i++) {
      const formattedDate = dateFns.format(day, "yyyy-MM-dd"); // Match API date format
      const cloneDay = day;
      const isDisabled =
        dateFns.isBefore(day, startDate) ||
        dateFns.isAfter(day, endDate) ||
        dateFns.isAfter(day, currentDate);

      const isSelected = selectedDates?.some((date) =>
        dateFns.isSameDay(day, date)
      );

      const isToday = dateFns.isSameDay(day, currentDate);
      // const isHoliday = holidayList.includes(formattedDate);
      // const isWeekend = satSunList.includes(formattedDate);

      const isHoliday = (holidayList || []).includes(formattedDate);
      const isWeekend = (satSunList || []).includes(formattedDate);

      // presentList
      const isPresent = (presentList || []).includes(formattedDate);
      // absentList
      const isAbsent = (absentList || []).includes(formattedDate);
      // regPendingList
      const isRegPending = (regPendingList || []).includes(formattedDate);

      // leaveListSession
      // const leaveSessions = leaveListSession?.[formattedDate] || [];
      // const isFullyRestricted = leaveSessions.includes("Session 1") && leaveSessions.includes("Session 2");
      // const isPartiallyRestricted = leaveSessions.length > 0 && !isFullyRestricted;

      // leaveListSession object

      const leaveSessions = leaveListSession?.[formattedDate] || [];

      // logic
      const hasSession1 = leaveSessions.includes("Session 1");
      const hasSession2 = leaveSessions.includes("Session 2");

      let isFullyRestricted = false;
      let isPartiallyRestricted = false;

      if (hasSession1 && !hasSession2) {
        // Only session1 exists → fully restricted
        isFullyRestricted = true;
      } else if (hasSession1 && hasSession2) {
        if (
          leaveSessions.includes("Session 1") &&
          leaveSessions.includes("Session 2")
        ) {
          // Both applied → fully restricted
          isFullyRestricted = true;
        } else {
          // Only one applied → partially restricted
          isPartiallyRestricted = true;
        }
      } else if (hasSession2 && !hasSession1) {
        // Only session2 exists (if needed treat same as fully)
        isFullyRestricted = true;
      }

      // Get attendance data for the current day
      const attendanceRecord = absentPresentData.attendanceData?.find(
        (record) => record.attendanceDate === formattedDate
      );
      const attendanceStatus = attendanceRecord ? attendanceRecord.attendanceData : null;
      const regularizationStatus = attendanceRecord ? attendanceRecord.regularization : null;
      const isApproved = regularizationStatus === "Approved";
      const isRejected = regularizationStatus === "Rejected";

      days.push(
        <Grid item xs key={day.getTime()} sx={{ display: "flex", justifyContent: "center", p: 0 }}>
          <Box
            className={`${isDisabled ? "disabled" : ""} 
                        ${isSelected ? "selected" : ""} 
                        ${isToday ? "today" : ""} 
                        ${isHoliday ? "holiday" : ""} 
                        ${isAbsent ? "absent" : ""} 
                        ${isWeekend ? "weekend" : ""} 
                        ${isPresent ? "present" : ""}`}
            onClick={() => (isDisabled ? null : onDateClick(cloneDay))}
            sx={{
              width: { xs: 32, sm: 40 },
              height: { xs: 32, sm: 40 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: isToday ? "3px" : 0,
              cursor: isDisabled ? "default" : "alias",
              color: isToday ? "text.primary" : "text.secondary",
              backgroundColor: isToday ? "primary.main" : "transparent",
            }}
          >
            <Typography
              color={
                isDisabled
                  ? (theme) => theme.palette.BudgieThemeColor.Neutrals[700]
                  : isToday
                    ? (theme) => theme.palette.BudgieThemeColor.BaseWhite
                    // : isHoliday
                    //   ? "primary.main"
                    :
                    isRegPending
                      ? "warning.main"
                      : isApproved
                        ? "success.main"
                        : isRejected
                          ? "error.main"
                          : isAbsent
                            ? "error.main" // Red for Absent
                          : isWeekend
                            ? "info.main"
                            : isPresent
                              ? "success.main" // Green for Present
                              : isSelected
                                ? "primary.main"
                                : isFullyRestricted
                                  ? "#9c27b0"
                                  : isPartiallyRestricted
                                    ? "error.main"
                                    : "text.primary"
              }
            >
              {dateFns.format(day, dateFormat)}
            </Typography>
          </Box>
        </Grid>
      );

      day = dateFns.addDays(day, 1);
    }

    rows.push(
      <Grid container key={day.getTime()} sx={{ mt: 1 }}>
        {days}
      </Grid>
    );
    days = [];
  }

  return <Box>{rows}</Box>;
};

export default CalendarCells;
